import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoice-product-calculator".
// Pricing JSON lives in #invoice-product-pricing-data (see pages/invoices/shared/_product_pricing_json_script).
// Turbo-appended rows rely on delegation; new lines get rate/amount from the server.
export default class extends Controller {
  connect() {
    this.onInput = this.handleInput.bind(this)
    this.onChange = this.handleProductChange.bind(this)
    this.element.addEventListener("input", this.onInput)
    this.element.addEventListener("change", this.onChange)

    this.element.querySelectorAll('[data-js="field-duplicatee"]').forEach((duplicatee) => {
      this.applyProductPricing(duplicatee, { onlyIfRateBlank: true })
    })
  }

  disconnect() {
    this.element.removeEventListener("input", this.onInput)
    this.element.removeEventListener("change", this.onChange)
  }

  readPricing() {
    const el = document.getElementById("invoice-product-pricing-data")
    if (!el?.textContent?.trim()) return {}
    try {
      return JSON.parse(el.textContent)
    } catch {
      return {}
    }
  }

  handleInput(event) {
    const input = event.target
    const fieldName = input.name

    if (!fieldName || (!fieldName.includes("[qty]") && !fieldName.includes("[rate]"))) {
      return
    }

    const duplicatee = input.closest('[data-js="field-duplicatee"]')
    if (!duplicatee) return

    this.syncAmount(duplicatee)
  }

  handleProductChange(event) {
    const select = event.target
    if (!select.matches?.("select[name*='[product]']")) return

    const duplicatee = select.closest('[data-js="field-duplicatee"]')
    if (!duplicatee) return

    this.applyProductPricing(duplicatee, { onlyIfRateBlank: false, productSelect: select })
  }

  applyProductPricing(duplicatee, options = {}) {
    const { onlyIfRateBlank = false, productSelect: selectOverride } = options

    if (duplicatee.style.display === "none") return

    const select =
      selectOverride || duplicatee.querySelector("select[name*='[product]']")
    if (!select) return

    const qtyInput = duplicatee.querySelector('input[name*="[qty]"]')
    const rateInput = duplicatee.querySelector('input[name*="[rate]"]')
    const amountInput = duplicatee.querySelector('input[name*="[amount]"]')

    if (!qtyInput || !rateInput || !amountInput) return

    const pricing = this.readPricing()
    const rateFilled = rateInput.value.trim() !== ""
    if (onlyIfRateBlank && rateFilled) return

    const product = select.value

    if (Object.prototype.hasOwnProperty.call(pricing, product)) {
      const rate = pricing[product]
      rateInput.value =
        typeof rate === "number" ? rate.toFixed(2) : String(rate ?? "")
      this.syncAmount(duplicatee)
    } else {
      rateInput.value = ""
      amountInput.value = ""
    }
  }

  syncAmount(duplicatee) {
    const qtyInput = duplicatee.querySelector('input[name*="[qty]"]')
    const rateInput = duplicatee.querySelector('input[name*="[rate]"]')
    const amountInput = duplicatee.querySelector('input[name*="[amount]"]')

    if (!qtyInput || !rateInput || !amountInput) return

    const qty = parseFloat(qtyInput.value) || 0
    const rate = parseFloat(rateInput.value) || 0
    amountInput.value = (qty * rate).toFixed(2)
  }
}
